import { render, staticRenderFns } from "./OaoFormTextArea.vue?vue&type=template&id=63ded914"
import script from "./OaoFormTextArea.vue?vue&type=script&lang=js"
export * from "./OaoFormTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports